import { Box, Paper } from '@material-ui/core'
import { createPopup } from '@typeform/embed'
import { CoproSummaryEdit } from '../../ext_coprosummary'
import { CoproFicheExtView } from '../fiche/ext_copros_fiche'
import {
  ADF,
  AGDoc,
  BlankSection,
  DocsCopro,
  Dashboard,
  ExtCoproInvoiceList,
  ExtCoproTicketCreate,
  ExtCoproTicketList,
  IntroSection,
  Mec,
  PrefContact,
  ExtCoproTicketAccountingList,
} from './partials'

import { RGDD } from '../RGDD'
import { BankingHistoryExtranet } from '../BankingHistory'
import { BudgetOverview } from '../BudgetOverview'
import ExtAG from '../ExtAG'

export const Content = ({ copro, coproprietaire, selectedItem }) => {
  const id = selectedItem?.id
  const EMBED_TYPEFORM_POPUP_SIZE = 100
  const workTypeformId = 'ABJsWRu2'
  const rentalTypeformId = 'uq0rEVOr'
  const sellTypeformId = 'GMyj5p'
  const beepTypeformId = 'nz5srZ'
  const createWorkPopup = () =>
    createPopup(workTypeformId, { size: EMBED_TYPEFORM_POPUP_SIZE }).open()
  const createRentalPopup = () =>
    createPopup(rentalTypeformId, { size: EMBED_TYPEFORM_POPUP_SIZE }).open()
  const createSellPopup = () =>
    createPopup(sellTypeformId, { size: EMBED_TYPEFORM_POPUP_SIZE }).open()
  const createBeepPopup = () =>
    createPopup(beepTypeformId, { size: EMBED_TYPEFORM_POPUP_SIZE }).open()
  switch (id) {
    case 'Mes documents':
      return (
        <>
          <DocsCopro
            id={copro?.copros_monday_internal_id}
            coproprietaire_id={coproprietaire.id}
          />
        </>
      )
    case 'Accueil':
      return <Dashboard copro={copro} coproprietaire_id={coproprietaire.id} />
    case 'Actions de la copro':
    case 'Interventions':
      return (
        <>
          <CoproSummaryEdit
            id={copro?.copros_monday_internal_id}
            coproprietaire_id={coproprietaire.id}
            syncWithLocation={false}
          />
        </>
      )
    case 'Assemblées générales':
      return (
        <>
          <ExtAG
            copro_id={coproprietaire.copro.id}
            coproprietaire_id={coproprietaire.id}
          />
        </>
      )
    case 'Informations & Documents':
      return (
        <CoproFicheExtView
          id={copro?.copros_monday_internal_id}
          resource={'ext_copros_fiche'}
        />
      )

    case 'Mises en concurrence':
      return <Mec copro={copro} coproprietaire={coproprietaire} />
    case 'Mes préférences':
      return <PrefContact coproprietaire={coproprietaire} />
    case 'Demander une intervention':
      return (
        <ExtCoproTicketCreate
          copro_id={copro.id}
          copro_internal_id={copro.copro_internal_id}
          coproprietaire_id={coproprietaire.id}
        />
      )
    case 'Questions comptables':
      return (
        <ExtCoproTicketAccountingList
          copro={copro}
          coproprietaire={coproprietaire}
        />
      )
    case 'Mes demandes':
      return (
        <ExtCoproTicketList
          copro_id={copro.id}
          coproprietaire={coproprietaire}
        />
      )
    case 'Tous mes appels de fonds':
      return (
        <ADF coproprietaire={coproprietaire} key={'tous-mes-appels-de-fonds'} />
      )
    case 'Mon dernier appel de fonds':
      return (
        <ADF
          coproprietaire={coproprietaire}
          only_last={true}
          key={'mon-dernier-appel-de-fonds'}
        />
      )
    case "Tous mes documents d'AG":
      return (
        <AGDoc coproprietaire={coproprietaire} key={'tous-mes-documents-dag'} />
      )
    case 'Suivi des factures copro':
      return (
        <ExtCoproInvoiceList
          copro_id={coproprietaire.copro.id}
          coproprietaire_id={coproprietaire.id}
        />
      )
    case 'RGDD':
      return <RGDD coproId={copro.copro_internal_id} />
    case 'Compte Bancaire':
      return <BankingHistoryExtranet coproId={copro.copro_internal_id} />
    case 'Budget':
      return <BudgetOverview coproId={copro.copro_internal_id} />
    case 'Mes travaux':
      createWorkPopup()
      return <></>
    case 'Mettre en location':
      createRentalPopup()
      return <></>
    case 'Mettre en vente':
      createSellPopup()
      return <></>
    case 'Demander un nouveau Bip':
      createBeepPopup()
      return <></>
    default:
      return <BlankSection />
  }
}
